import { Component } from "@angular/core";

@Component({
  template: `
    <div class="modal-body border-bottom border-2 border-primary pb-0">
      <div class="p-1">
        <div class="d-flex mb-2">
          <i class="text-primary fa-sharp fa-solid icone-esquerdo fa-triangle-exclamation"></i>
          <div class="ms-2">
            <h5 class="mb-2 text-primary">Acesso Negado</h5>
            <div class="text-muted">
              <small>O usuário logado não tem permissão para acessar esta tela.</small>
            </div>
          </div>
        </div>
      </div>
      <hr class="mx-1 my-0">
      <div class="modal-footer pe-0">
        <button class="btn btn-primary mensagem-flutuante-btn rounded-1" (click)="fechar()">
          OK
        </button>
      </div>
    </div>
  `,
})
export class AcessoNegadoContentComponent {
  onFechar: () => void = () => {};

  fechar(): void {
    this.onFechar();
  }
}
